import React, { useEffect } from 'react';
import { useState } from "react";
import styles from "./TreeView.module.css";
import request from "../../utils/request";
import { getUserCompany } from '../../utils/sessionHandler';
import ModalLoading from '../ModalLoading/ModalLoading';

  
const TreeView = () => {
    const [expanded, setExpanded] = useState({});
    const [materialState, setMaterialState] = useState([])
    const [loading,setLoading] = useState([])

    const toggleExpand = (id) => {
      setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const getMaterialState = async () => {
      try {
        setLoading(true);
        let res = await request().get(`/api/materialStock/listByStatus?CompanyId=${getUserCompany().Id}`);
        setMaterialState(res.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching materials:", error);
      }
    };

    useEffect(() => {
        getMaterialState();
      }, []);

    return (
      <div className={styles.treeContainer}>
          <ModalLoading open={loading} />
        {/* Tarjeta inicial con títulos Status y Total */}
        <div className={styles.headerCard}>
          <div className={styles.cardRow}>
            <span>Status</span>
            <span>Total</span>
          </div>
        </div>
        {materialState.map((node) => (
          <div key={node.statusMaterialId} className={styles.treeNode}>
            <div className={styles.nodeHeader}>
              <div className={styles.connector}></div>
              <button
                className={styles.toggleButton}
                onClick={() => toggleExpand(node.statusMaterialId)}
              >
                {expanded[node.statusMaterialId] ? "-" : "+"}
              </button>
              <div className={styles.card}>
                <div className={styles.cardRow}>
                  <span>{node.statusMaterial}</span>
                  <span>{node.totalQuantity}</span>
                </div>
              </div>
            </div>
            
            {expanded[node.statusMaterialId] && (
              <div className={styles.subNodes}>
                {/* Tarjeta con títulos Material y Quantity */}
                <div className={styles.materialHeader}>
                  <div className={styles.cardRow}>
                    <span>Material</span>
                    <span>Quantity</span>
                  </div>
                </div>
                {node?.quantityByMaterial.map((mat) => (
                  <div key={mat.id} className={styles.subNode}>
                    <div className={styles.connector}></div>
                    <div className={styles.cardSmall}>
                      <div className={styles.cardRow}>
                        <span>{mat?.name}</span>
                        <span>{mat?.quantity}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  export default TreeView;
